import React, {useEffect} from 'react';
import {logPageLoadEvents} from '@ibibo/analytics';
import KycInfo from './containers/KycInfo';
import {useSelector, useDispatch} from 'react-redux';
import {userDataSelector, prevPageNameSelector} from '../../store/selectors';

import {updatePreviousPageName} from '../../store/actions'

import Onboarding from '../../stories/components/Onboarding/onboarding';

const DetailsPage = () => {

  const userInfo = useSelector(userDataSelector);
  const { email, mobile, requestIp, accountId } = userInfo;
  const data = useSelector(prevPageNameSelector);
  const {prevPageName} = data;
  const dispatch = useDispatch();
  
  useEffect(() => {
      const events = {
        eVar34: email,
        eVar35: mobile,
        eVar23: prevPageName,
        eVar28: requestIp,
        eVar67: accountId,
        eVar24: "onboarding|mypartner",
        eVar37: "domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng",
      }

    logPageLoadEvents('onboarding:businessdetails', events);
    dispatch(updatePreviousPageName("onboarding:businessdetails"));

  }, [dispatch]);

  return (
    <Onboarding step={3}>
      <KycInfo />
    </Onboarding>
  );
};

export default DetailsPage;
